import { DropDownOption } from 'src/types';

export const findOption = (value: string, options: DropDownOption[]) => {
  return options.find((o) => o.name.toLowerCase() === value.toLowerCase());
};
